import { getAxiosInstance1 } from "../ApiConfig";

async function getCityData(isoCode) {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/fetchAllCities/${isoCode}`);
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getStateData(isoCode) {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/fetchAllStates/${isoCode}`);
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllUsersData() {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/findAllActiveUser`);
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllUsersByAdmin() {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/fetchAllUserByAdmin`);
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchAllAttendeeList() {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/fetchAllParticipants`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function IndustryData() {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/fetchAllIndustry`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getLeadsourceData() {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/fetchAllLeadSource`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getLeadStatusData() {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/fetchAllLeadStatus`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getSeniorityLevelData() {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/fetchAllSeniorityLevel`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCountryData() {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/fetchAllCountries`);
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getColumnConfigs(value) {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/UserDataConfigs/${value}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function SharingPermissions(entity, id, sharingId) {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/findSharingForPermission/${entity}/${id}/${sharingId}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function MultiFileUpload(formData) {
    try {
        const response = await getAxiosInstance1().post(`/usermgmt/uploadMultipleFiles`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getMyTerritory() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/findAllTerritoryByAssignto`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTeamTerritory(value) {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/findAllTerritoryByUserId/${value}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getBusinessRuleEntity() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/getAllEntityTypeForAutomation`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTriggerFiledforEntity(name) {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/getAllRequestField/${name}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTimeZoneData() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/fetchAllTimeZone`);
        const cleanedList = data.data.data.map(item => ({
            ...item,
            timeZone: item.timeZone.replace(/\s\d{2}:\d{2}:\d{2}$/, "")
        }));
        return cleanedList
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCompanyRole() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/getAllCompanyRolesByUser`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getSystemRole() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/getAllSystemRoleByAdmin`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getLanguage() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/fetchAllLanguage`);
        return data.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTitle() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/fetchAllTitle`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAnnualRevenue() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/fetchAllAnnualRevenue`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getNoofEmployee() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/fetchAllNomOfEmployee`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getRating() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/fetchAllRating`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getProdCategory() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/fetchAllProductCategory`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getUserDepartment() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/fetchAllDepartment`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getDateFormate() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/fetchAllDateFormat`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTimeFormate() {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/fetchAllTimeFormat`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchDealByEntity(id, entity) {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/getRelateEntityData/${id}/${entity}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getScoringDetails(name, id) {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/findAllEntityScoringByEntityTypeAndId/${name}/${id}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getMailInfo(company, email) {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/fetchDetailUsingEmail/${company}/${email}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FecthModuleEncryptedToken(id, companyId) {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/generateTokenUsingIdByApikey/${id}/${companyId}/crm_square_Cxsquare@481!`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FecthModuleDecryptedToken(token, companyId) {
    try {
        const data = await getAxiosInstance1().get(`/usermgmt/decodeTokenByApikey/${token}/${companyId}/crm_square_Cxsquare@481!`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FecthTableNames() {
    try {
        const data = await getAxiosInstance1().get(`/Template/getAllEntityTableName`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function replaceVariablesForSendInvoicePaymentLink(payload) {
    try {
        const response = await getAxiosInstance1().post(`/usermgmt/replaceVariablesForSendInvoicePaymentLink`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAllSystemLogByModule(module) {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/findAllSystemLogByModuleAndApikey/${encodeURIComponent(module)}/crm_square_Cxsquare@481!`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAllLicenseSystemLog(licenseManagementId) {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/findAllLicenseSystemLog/${licenseManagementId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAllExportLogsByCompany(companyId) {
    try {
        const response = await getAxiosInstance1().get(`/usermgmt/findAllExportLogsByCompany/${companyId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    findAllExportLogsByCompany,
    getCityData,
    getStateData,
    getAllUsersData,
    IndustryData,
    getLeadsourceData,
    getLeadStatusData,
    getSeniorityLevelData,
    getCountryData,
    getColumnConfigs,
    SharingPermissions,
    MultiFileUpload,
    FetchAllAttendeeList,
    getMyTerritory,
    getTeamTerritory,
    getBusinessRuleEntity,
    getTriggerFiledforEntity,
    getTimeZoneData,
    getLanguage,
    getSystemRole,
    getCompanyRole,
    getTitle,
    getAnnualRevenue,
    getNoofEmployee,
    getRating,
    getProdCategory,
    getUserDepartment,
    getDateFormate,
    getTimeFormate,
    FetchDealByEntity,
    getScoringDetails,
    getMailInfo,
    getAllUsersByAdmin,
    FecthTableNames,
    FecthModuleDecryptedToken,
    FecthModuleEncryptedToken,
    replaceVariablesForSendInvoicePaymentLink,
    findAllSystemLogByModule,
    findAllLicenseSystemLog,
}